import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import { useAuth } from "../hooks/useAuth";
import Footer from "../components/CommonComponents/Footer";
import "../index.css";
import { getSuperadminLoginAccent } from "../constants/loginTheme";

export default function SuperadminLogin() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const { login } = useAuth();
    const loginAccent = getSuperadminLoginAccent();

    // Handle login submit
    const handleLogin = async (e) => {
        e.preventDefault();
        if (!username.trim() || !password.trim()) {
            toast.error("Please enter both username and password");
            return;
        }
        const success = await login({ username, password }, "superadmin");
        if (success) {
            navigate("/superadmin/dashboard");
        }
    };

    return (
        <div className="flex min-h-screen bg-[#f7f8fa]">
            {/* Login Form Only, No Animation */}
            <div className="flex flex-col justify-center items-center w-full px-4 transition-all duration-300">
                <div className="w-full max-w-sm bg-white p-8 rounded-md shadow border border-gray-100">
                    <h2 className="text-center text-xl font-semibold mb-6" style={{ color: loginAccent }}>SuperAdmin Login</h2>
                    <form onSubmit={handleLogin} className="space-y-4">
                        <div className="relative">
                            <FaUser className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: loginAccent }} />
                            <input
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                placeholder="Username"
                                className="pl-10 pr-3 py-2 border border-gray-300 rounded-md w-full text-sm focus:outline-none focus:ring-2"
                                style={{ color: '#111', boxShadow: `0 0 0 2px transparent`, caretColor: loginAccent }}
                                autoComplete="username"
                                onFocus={e => e.target.style.boxShadow = `0 0 0 2px ${loginAccent}`}
                                onBlur={e => e.target.style.boxShadow = `0 0 0 2px transparent`}
                            />
                        </div>
                        <div className="relative">
                            <FaLock className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: loginAccent }} />
                            <input
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="Password"
                                className="pl-10 pr-10 py-2 border border-gray-300 rounded-md w-full text-sm focus:outline-none focus:ring-2"
                                style={{ color: '#111', boxShadow: `0 0 0 2px transparent`, caretColor: loginAccent }}
                                autoComplete="current-password"
                                onFocus={e => e.target.style.boxShadow = `0 0 0 2px ${loginAccent}`}
                                onBlur={e => e.target.style.boxShadow = `0 0 0 2px transparent`}
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 focus:outline-none"
                                tabIndex={-1}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        <p className="text-xs text-gray-600 text-center">
                            Superadmin access only. Use your credentials.
                        </p>
                        <button
                            type="submit"
                            className="w-full font-semibold py-2 rounded-md transition text-sm"
                            style={{ background: loginAccent, color: '#fff' }}
                        >
                            Log In
                        </button>
                    </form>
                </div>
            </div>
            {/* Footer */}
            <Footer
                className="text-xs text-gray-500 py-4 absolute bottom-0 w-full"
                noBorder
                noPadding
                showLegalLinks
            />
        </div>
    );
}
